import { useFlags } from 'launchdarkly-react-client-sdk'
import { styled } from '../../lib/stitches'
import { Flex } from './Flex'
import Text from './Text/Text'

const StyledFlex = styled(Flex, {
  alignItems: 'center',
  justifyContent: 'center',
  padding: '16px 0px',
  backgroundColor: '#675AF80D',
  width: '100%',
  '@tablet': {
    height: '40px'
  }
})

const StyledAnchorLink = styled('a', {
  display: 'flex',
  flexDirection: 'row',
  textAlign: 'center',
  flexWrap: 'nowrap',
  gap: '8px',
  '@mobile': {
    gap: '16px'
  }
})

export const AnnouncementHeader = () => {
  const flags = useFlags()

  if (!flags.announcementBanner) {
    return null
  }

  return (
    <StyledFlex>
      <StyledAnchorLink href="https://arpeggi.io/reo" target="_blank">
        <Text size="12" fontWeight="medium">
          🏆 Remix Reo's song Zoom for a chance to mint on Sound.xyz!
        </Text>
        <Text size="12" fontWeight="medium" css={{ color: '#675AF8' }}>
          Learn more
        </Text>
      </StyledAnchorLink>
    </StyledFlex>
  )
}
